import { waitSomeTime } from "./waitSomeTime";
import { mobileMenu } from "./mobileMenu";

export const awaitMobileMenu = async (element?: string) => {
  if (!element?.includes("Mobile")) return;
  const menuMobile = mobileMenu();
  if (menuMobile) {
    menuMobile.click();
    await waitSomeTime(500);
  }
};
